import React, { createContext, useContext, useState, ReactNode } from 'react';

export type DropdownsData = {
  brand: string[];
  color: string[];
  sku: string[];
  product_title: string[];
  subcategory: string[];
  category: string[];
  size: string[];
};

const defaultDropdownsData: DropdownsData = {
  brand: [],
  color: [],
  sku: [],
  product_title: [],
  subcategory: [],
  category: [],
  size: [],
};

interface DropdownsContextType {
  dropdowns: DropdownsData;
  setDropdowns: React.Dispatch<React.SetStateAction<DropdownsData>>;
  setDropdown: <K extends keyof DropdownsData>(key: K, value: string[]) => void;
}

const DropdownsContext = createContext<DropdownsContextType | undefined>(undefined);

export const DropdownsProvider = ({ children }: { children: ReactNode }) => {
  const [dropdowns, setDropdowns] = useState<DropdownsData>(defaultDropdownsData);

  const setDropdown = <K extends keyof DropdownsData>(key: K, value: string[]) => {
    setDropdowns(prev => ({ ...prev, [key]: value }));
  };

  return (
    <DropdownsContext.Provider value={{ dropdowns, setDropdowns, setDropdown }}>
      {children}
    </DropdownsContext.Provider>
  );
};

export const useDropdowns = () => {
  const context = useContext(DropdownsContext);
  if (!context) {
    throw new Error('useDropdowns must be used within a DropdownsProvider');
  }
  return context;
};